/* eslint-disable */
import { Button, FormControlLabel, Grid, Switch, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import HelpIcon from '@material-ui/icons/Help';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_PLACE_ORDER_PLUS_LOAD_HELP_CLOSE,
  UI_PLACE_ORDER_PLUS_LOAD_HELP_OPEN,
  UI_PLACE_ORDER_PLUS_LOAD_TOGGLE_SWITCHED,
} from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * PlusLoad
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const PlusLoad = ({ actions, classes, isOn, onChange, disabled }) => {
  const [showHelp, setShowHelp] = useState(false);

  /**
   * Toggle handler, report currest state of switches to parent component
   * @returns {void} void
   */
  const toggleChecked = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPlusLoadToggleSwitched`,
        },
      },
      type: UI_PLACE_ORDER_PLUS_LOAD_TOGGLE_SWITCHED,
    });
    onChange({ isOn: !isOn });
    return;
  };

  /**
   * Opens modal
   * @returns {void} void
   */
  const openModal = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPlusLoadHelpOpen`,
        },
      },
      type: UI_PLACE_ORDER_PLUS_LOAD_HELP_OPEN,
    });
    setShowHelp(true);
    return;
  };

  /**
   * Closes modal
   * @returns {void} void
   */
  const closeModal = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPlusLoadHelpClose`,
        },
      },
      type: UI_PLACE_ORDER_PLUS_LOAD_HELP_CLOSE,
    });
    setShowHelp(false);
    return;
  };

  return (
    <React.Fragment>
      <Modal
        preventFullScreen
        maxWidth="sm"
        title={<Typography variant="h6">Plus Load switch</Typography>}
        content={
          <Typography variant="body2">
            Turn on this switch to include a plus load. Specify and confirm your plus load on the day of delivery using Boral Connects or by calling Boral.
          </Typography>
        }
        onClose={closeModal}
        open={!!showHelp}
        paperClasses={classes.paperClasses}
        footer={
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <Button variant="contained" color="primary" onClick={closeModal}>
                Ok
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Grid item className={classes.switches}>
        <Grid container alignItems="center">
          <Grid item className={classes.flexGrow1}>
            <FormControlLabel
              control={<Switch disabled={disabled} color="primary" checked={!!isOn} onChange={toggleChecked} />}
              label={
                <Typography variant="body2" className={disabled && classes.opacity05}>
                  I will be ordering a <span className={classes.fontWeight500}>Plus Load</span>
                </Typography>
              }
            />
            {!disabled && <HelpIcon fontSize="small" onClick={openModal} className={classes.helpIcon} />}
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
PlusLoad.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  isOn: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(PlusLoad);
